export default {
  ctaText: "Apply the adjustments",
  financialOverviewSidePanelTag: "End of the day",
  headerButtonText: "Last Results",
  headerLabel: "Current selling price",
  sidePanelSubtitle: "An opportunity to offer a discount.",
  sidePanelTitle: "Price markdown.",
  title: "You can define a new end-of-day price of your products"
};
